import React, { Component } from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import Routes from "./components/routes/routes";
import { connect } from "react-redux";

export default connect()(
  class App extends Component {
    render() {
      return (
        <BrowserRouter basename="/business">
            <Routes />
            <div>
            <a href="https://wa.me/+2348165770446" rel="noopener noreferrer"
                class="float" target="_blank">
                <i class="fa fa-whatsapp my-float">Support</i>  <span id="support">Support</span>
              </a>
          </div>

        </BrowserRouter>
      );
    }
  }
);
